var _path, _path2, _path3;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgRatingGrey(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 40,
    height: 20,
    viewBox: "0 0 40 20",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M1 8.5H13.5V19.5H1C0.723858 19.5 0.5 19.2761 0.5 19V9C0.5 8.72386 0.723858 8.5 1 8.5Z",
    fill: "#F7F8FA",
    stroke: "#A9AAAF"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M14 0.5H26C26.2761 0.5 26.5 0.723858 26.5 1V19.5H13.5V1C13.5 0.723858 13.7239 0.5 14 0.5Z",
    fill: "#F7F8FA",
    stroke: "#A9AAAF"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M39 10.5C39.2761 10.5 39.5 10.7239 39.5 11V19C39.5 19.2761 39.2761 19.5 39 19.5H26.5V10.5H39Z",
    fill: "#F7F8FA",
    stroke: "#A9AAAF"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgRatingGrey);
export default __webpack_public_path__ + "static/media/rating-grey.d05b9d144d6c95fa85573f1b76aa9d17.svg";
export { ForwardRef as ReactComponent };